export default "__VITE_ASSET__044da27a__"